import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import styles from "./ReceiptPage.module.css";
import { useAccount } from "../utils/AccountInfoContext";
import "../assets/icons.css";
import Loader from "components/Loader";
import moment from "moment";
import mobile from "mobileBridge";
import { useTranslation } from "react-i18next";

export function ReceiptPage() {
  const { t } = useTranslation();
  const { history } = useHistory();
  const { getReceipt } = useAccount();
  const { type, referenceId } = useParams();

  console.log("RECEIPT DATA", getReceipt);
  console.log("type, referenceId", type, referenceId);

  const [receipt, setReceipt] = useState(null);

  const handleReceipt = async (type, referenceId) => {
    let _receipt = await getReceipt.mutateAsync({
      type: type,
      referenceId: referenceId,
    });
    setReceipt(_receipt);

    console.log("_receipt", _receipt);
  };

  useEffect(() => {
    handleReceipt(type, referenceId);
  }, []);

  const formatNumber = (number) => {
    let numStr = number?.toFixed(2)?.toString() || null;
    let retStr = "";
    if (numStr && numStr.length > 0 && numStr[0] == "-") {
      retStr = numStr[0] + "$" + numStr.substr(1, numStr.length);
    } else if (numStr && numStr.length > 0) {
      retStr = "$" + numStr;
    } else if (!numStr) {
      retStr = "N/A";
    }
    return retStr;
  };

  const handleMobilePrint = async () => {
    mobile.openLink(`${window.location}`);
  };

  return (
    <div className={styles.container}>
      {receipt ? (
        <div className={styles.content}>
          <div className={styles.row1}>
            <i
              class="fa-solid fa-chevron-left"
              style={{
                fontSize: "24px",
                marginRight: "-34px",
                paddingTop: "8px",
                color: "#243746",
              }}
              onClick={() => window.history.back()}
            />
            <i
              class="main fa fa-users"
              aria-hidden="true"
              style={{ fontSize: "42px", color: "#4b4e52" }}
            />
            <span className={styles.headerText}>{t("Membership Receipt")}</span>
          </div>
          <div className={styles.receipt} id="print">
            <div className={styles.row2}>
              <div className={styles.header}>
                <span
                  className="icon-diamond"
                  style={{ fontSize: "24px", color: "#243746" }}
                />
                <span className={styles.headerText}>
                  {t("Membership Receipt")}
                </span>
              </div>
            </div>
            <div className={styles.row3}>
              <div className={styles.rowItem}>
                <span className={styles.label}>{t("IBO Number")}</span>
                <span className={styles.data}>{receipt?.IBO || "N/A"}</span>
              </div>
              <div className={styles.rowItem}>
                <span className={styles.label}>{t("Name")}</span>
                <span className={styles.data}>{receipt?.Name || "N/A"}</span>
              </div>
              <div className={styles.rowItem}>
                <span className={styles.label}>{t("Confirmation")}</span>
                <span className={styles.data}>
                  {receipt?.Confirmation || "N/A"}
                </span>
              </div>
              <div className={styles.rowItem}>
                <span className={styles.label}>{t("Order Date")}</span>
                <span className={styles.data}>
                  {moment(new Date(receipt?.ProcessedOn)).format(
                    "MM.DD.YYYY"
                  ) || "N/A"}
                </span>
              </div>
              <div className={styles.rowItem}>
                <span className={styles.label}>{t("Renewal Date")}</span>
                <span className={styles.data}>
                  {moment(new Date(receipt?.RenewalOn)).format("MM.DD.YYYY") ||
                    "N/A"}
                </span>
              </div>
            </div>
            <div className={styles.banner}>
              {receipt.Status == 1 ? (
                <span className={styles.subheader}>{"Order Complete"}</span>
              ) : receipt.Status == 2 ? (
                <span className={styles.subheaderError}>
                  {t("Order Cancelled")}
                </span>
              ) : receipt.Status == 3 ? (
                <span className={styles.subheader}>{t("Order Pending")}</span>
              ) : (
                <span className={styles.subheaderError}>
                  {t("Payment Failed")}
                </span>
              )}
            </div>

            <div className={styles.receiptHeader}>
              <span>{t("Item(s) Purchased")}</span>
            </div>

            <div className={styles.receiptItems}>
              <div className={styles.tableHeader}>
                <span className={styles.col1}>{t("Item")}</span>
                <span className={styles.col2}>{t("Amount")}</span>
                <span className={styles.col3}>{t("Details")}</span>
              </div>
              <div className={styles.tableContent}>
                {receipt.Items.map((item) => {
                  console.log("receipt.Items", receipt.Items);
                  console.log("item", item);

                  return (
                    <div className={styles.tableRow}>
                      <span className={styles.col1}>
                        {item.Description}
                        <span className={styles.underDesc}>{item.Note}</span>
                      </span>
                      <span className={styles.col2}>
                        {formatNumber(item.Amount)}
                      </span>
                      <span className={styles.col3}>{item?.Note}</span>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className={styles.receiptHeader}>
              <span>{t("Payment Information")}</span>
            </div>
            <div className={styles.row3}>
              <div className={styles.rowItem}>
                <span className={styles.label}>{t("Total")}</span>
                <span className={styles.data}>
                  {formatNumber(receipt?.Total)}
                </span>
              </div>
              <div className={styles.rowItem}>
                <span className={styles.label}>{t("Payment")}</span>
                <span className={styles.data}>
                  {receipt?.Payment?.Description || "N/A"}
                </span>
              </div>
            </div>
          </div>
          {!mobile.isApp() && (
            <div className={styles.buttonContainer}>
              <button
                onClick={() => {
                  mobile.isApp() ? handleMobilePrint() : window.print();
                }}
              >
                <i className="fa fa-print" /> {t("Print")}
              </button>
            </div>
          )}
        </div>
      ) : getReceipt.isLoading ? (
        <div className={styles.loader}>
          <Loader color={"#415364"} size={85} />
        </div>
      ) : (
        getReceipt.isError && (
          <div className={styles.error}>
            {t("We have encountered an error", { referenceId })}
          </div>
        )
      )}
    </div>
  );
}

export default ReceiptPage;
